import React, { useRef, useEffect, useState } from 'react'
import { Row, Col, Input, Card } from 'antd'
import { useSelector } from 'react-redux'
import { formatMessageNew } from '@/utils/common'
import { modalSuccess, modalError, destroyModal } from '@/utils/modalUtils'
import { unbindByCarton } from '@/services/qrCode/unbind'
let errorModal = null
let successModal = null
let errorNum = 0
const QrCodeUnbindByCartonPageWeb = () => {
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [themeObj] = useState({ width: 500 * deviceSize, padding: 16 * deviceSize })
  const cartonInputRef = useRef(null)
  const [cartonNoValue, setCartonNoValue] = useState('')
  const [inputReadOnly, setInputReadOnly] = useState(false)
  // 页面初始化
  useEffect(() => {
    cartonInputRef.current.focus({ cursor: 'all' })
    // 监听全局键盘事件
    window.addEventListener('keydown', onWindowKeyDown)
    window.addEventListener('keyup', onWindowKeyUp)
    return () => {
      // 移除全局键盘事件
      window.removeEventListener('keydown', onWindowKeyDown)
      window.removeEventListener('keyup', onWindowKeyUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 弹出 输入框要失焦点，防止再次触发回车事件
  // useEffect(() => {
  //   cartonInputRef.current.blur()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [errorModal, successModal])

  // 全局键盘事件
  const onWindowKeyDown = e => {
    console.log('e.keyCode', e.keyCode)
    if (e.keyCode === 13) {
      // 关闭 错误提示弹窗
      if (errorModal) {
        destroyModal(errorModal)
        errorModal = null
        errorNum = 0
      }
      // 关闭 成功提示弹窗
      if (successModal) {
        destroyModal(successModal)
        successModal = null
        errorNum = 0
      }
    }
  }
  // 全局键盘事件
  const onWindowKeyUp = e => {
    console.log('onWindowKeyUp', e.keyCode)
    if (e.keyCode === 13) {
      cartonInputRef.current.focus({ cursor: 'all' })
    }
  }

  const onInputChange = e => {
    const value = e.target.value.trim()
    const index = value.indexOf('/n')
    const newValue = index > -1 ? value.substring(0, index) : value
    setCartonNoValue(newValue)
  }

  const onInputKeyUp = e => {
    if (e.keyCode === 13) {
      console.log('onInputKeyUp')
      cartonInputRef.current.blur()
      unbindingFun()
    }
  }
  const onInputFocus = e => {
    setInputReadOnly(true)
    setTimeout(() => {
      setInputReadOnly(false)
    }, 100)
  }
  // 根据箱号获取订单信息

  const unbindingFun = () => {
    if (!cartonNoValue) {
      return
    }
    let params = {
      type: 0,
      cartonNumber: cartonNoValue
    }
    unbindByCarton(params, {})
      .then(res => {
        if (errorNum === 0) {
          errorNum = 1
          successModal = modalSuccess(
            {
              title: formatMessageNew('languageObj.qrCode.unbindByCartonSuccess'),
              content: (
                <div className="fwb">
                  {formatMessageNew('languageObj.qrCode.cartonNo')}: {cartonNoValue}
                </div>
              )
            },
            () => {
              cartonInputRef.current.focus({ cursor: 'all' })
              errorNum = 0
            }
          )
        }
      })
      .catch(err => {
        if (errorNum === 0) {
          errorNum = 1
          errorModal = modalError(
            {
              content: formatMessageNew('languageObj.qrCode.errorcode_' + err.errorCode)
            },
            () => {
              cartonInputRef.current.focus({ cursor: 'all' })
              errorNum = 0
            }
          )
        }
      })
  }
  return (
    <div className="displayFlex alignCenter justifyContentCenter h100">
      <div className="tag-container mt20" style={{ height: 'auto' }}>
        <Card
          style={{
            ...themeObj
          }}
          className="nfc_card"
        >
          <Row>
            <Col
              style={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
              span={24}
            >
              <div style={{ width: '150px', textAlign: 'left' }}>
                {formatMessageNew('languageObj.qrCode.cartonNo')}：
              </div>
              <Input
                className="pt5 pb5"
                ref={cartonInputRef}
                value={cartonNoValue}
                allowClear
                readOnly={inputReadOnly}
                placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}${formatMessageNew(
                  'languageObj.qrCode.cartonNo'
                )}`}
                onFocus={onInputFocus}
                onKeyUp={onInputKeyUp}
                onChange={onInputChange}
              />
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  )
}
export default QrCodeUnbindByCartonPageWeb
